/* =========================================================================
   Penny Premium 3D — related-products.js
   Fetches Shopify's product recommendations THROUGH the Section Rendering
   API, so the response is this very section rendered server-side with the
   real product-card + quick-add markup (full Liquid reuse, no client
   templates). Skeletons reserve exact heights until the swap; the section
   hides itself if there are no recommendations.
   ========================================================================= */

document.querySelectorAll('[data-related-products]').forEach(async (section) => {
  try {
    const response = await fetch(section.dataset.url);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-related-products]');

    if (fresh?.querySelector('[data-related-loaded]')) {
      section.replaceChildren(...fresh.childNodes);
      // Re-run shared initializers (slider.js listens for this)
      document.dispatchEvent(new Event('shopify:section:load'));
    } else {
      section.closest('.shopify-section').setAttribute('hidden', '');
    }
  } catch (_) {
    section.closest('.shopify-section').setAttribute('hidden', '');
  }
});
